import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Facebook, Instagram } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Início' },
    { path: '/clube', label: 'Clube' },
    { path: '/futebol', label: 'Futebol' },
    { path: '/jogos', label: 'Jogos' },
    { path: '/noticias', label: 'Notícias' },
    { path: '/patrocinadores', label: 'Patrocinadores' },
    { path: '/galeria', label: 'Galeria' },
    { path: '/contactos', label: 'Contactos' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/5" data-testid="navbar">
      <div className="container-custom section-padding">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
              <span className="font-heading font-black text-black text-lg">GDR</span>
            </div>
            <div className="hidden sm:block">
              <span className="font-heading font-bold text-xl tracking-tight">GDR ESPORÕES</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Social Links & Mobile Menu */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.facebook.com/gdresporoes"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
              data-testid="facebook-link"
            >
              <Facebook size={18} />
            </a>
            <a
              href="https://www.instagram.com/gdresporoes"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
              data-testid="instagram-link"
            >
              <Instagram size={18} />
            </a>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-white p-2"
              onClick={() => setIsOpen(!isOpen)}
              data-testid="mobile-menu-toggle"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden border-t border-white/10 py-4 animate-fade-in" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 text-sm uppercase tracking-widest font-bold ${
                  isActive(link.path) ? 'text-white' : 'text-gray-400'
                }`}
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
